<section class="sources" aria-label="Sources">
  @for (source of sources(); track source.id) {
    <app-card [tone]="source.tone" [badge]="badge(source)">
      <div card-title>
        <h2>{{ source.title }}</h2>
        @if (source.state === 'ready') {
          <p class="watching">{{ source.total | number }} {{ source.noun }} watched</p>
        }
      </div>

      @switch (source.state) {
        @case ('ready') {
          <p class="headline">{{ source.headline }}</p>
          <div class="meter" role="img" [attr.aria-label]="'Share of ' + source.noun + ' by state'">
            @for (part of segments(source); track part.key + part.label) {
              <span
                class="segment"
                [class]="'segment ' + toneClass(part.tone)"
                [style.flex-grow]="part.count"
                [attr.title]="part.count + ' ' + part.label"
              ></span>
            }
          </div>
          <ul class="legend">
            @for (part of source.parts; track part.key + part.label) {
              <li [class]="toneClass(part.tone)">
                <span class="dot" aria-hidden="true"></span>{{ part.count | number }}
                {{ part.label }}
              </li>
            }
          </ul>
          @if (source.problem) {
            <p class="notice">
              The latest read failed, so this may be out of date. {{ source.problem }}
            </p>
          }
        }
        @case ('unavailable') {
          <p class="message" role="alert">{{ source.problem }}</p>
        }
        @case ('empty') {
          <p class="message">{{ source.headline }}.</p>
        }
        @default {
          <p class="message">Reading the latest data…</p>
        }
      }

      <a class="details" [routerLink]="source.route"
        >View details<span class="visually-hidden"> of {{ source.title }}</span></a
      >
      @if (source.updated; as updated) {
        <span card-meta>Updated {{ age(updated) }}</span>
      }
    </app-card>
  }
</section>

<section class="panel" aria-labelledby="attention-title">
  <h2 id="attention-title">
    Needs attention
    @if (attention().length > 0) {
      <span class="count">{{ attention().length }}</span>
    }
  </h2>

  @if (attention().length === 0) {
    <p class="clear">
      {{
        anyReady()
          ? 'Nothing needs attention right now: no unhealthy or degraded roles and no dead letters.'
          : 'There is nothing to judge yet.'
      }}
    </p>
  } @else {
    <ul class="items">
      @for (item of shownItems(); track item.id) {
        <li [class]="toneClass(item.tone)">
          <a [routerLink]="item.route" (click)="open.emit(item)">
            <span class="what">
              <strong>{{ item.title }}</strong>
              @if (item.subtitle) {
                <span class="sub">{{ item.subtitle }}</span>
              }
            </span>
            <span class="detail">{{ item.detail }}</span>
            <span class="source">{{ item.sourceTitle }}</span>
          </a>
        </li>
      }
    </ul>
    @if (hiddenCount() > 0) {
      <p class="more">
        and {{ hiddenCount() }} more.
        <button type="button" class="link" (click)="expanded.set(true)">Show all</button>
      </p>
    }
  }
</section>
